"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactForm = _interopRequireDefault(require("@micado-digital/react-form"));
var _formContext = _interopRequireDefault(require("@micado-digital/react-form/context/formContext"));
var _Input = _interopRequireDefault(require("@micado-digital/react-form/Input"));
var _Button = _interopRequireDefault(require("@micado-digital/react-form/Button"));
var _Message = _interopRequireDefault(require("@micado-digital/react-form/Message"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Form = _interopRequireDefault(require("./Form.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FormContent = function FormContent(_ref) {
  var lang = _ref.lang,
    token = _ref.token;
  var _useContext = (0, _react.useContext)(_formContext.default),
    _useContext2 = _slicedToArray(_useContext, 1),
    formConfig = _useContext2[0];
  var _formConfig$errorFiel = formConfig.errorFields,
    errorFields = _formConfig$errorFiel === void 0 ? {} : _formConfig$errorFiel,
    formLocked = formConfig.formLocked,
    _formConfig$response = formConfig.response,
    _formConfig$response2 = _formConfig$response === void 0 ? {} : _formConfig$response,
    _formConfig$response3 = _formConfig$response2.data,
    _formConfig$response4 = _formConfig$response3 === void 0 ? {} : _formConfig$response3,
    formMsg = _formConfig$response4.msg;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    formMessageObj = _useState2[0],
    setFormMessageObj = _useState2[1];
  var navigate = (0, _useLink.default)();
  var css = (0, _Form.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(function () {
    if (!formMsg) return;
    switch (formMsg) {
      case "ok":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.success.ACCESSCODE_SEND",
              l: l
            }),
            type: "success"
          });
          setTimeout(function () {
            navigate("/".concat(lang, "/shop/digital-product?token=").concat(token));
          }, 3000);
          break;
        }
      case "parameter_missing":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ACCESSCODE_NOT_SEND",
              l: l
            }),
            type: "error"
          });
          break;
        }
      case "limit_reached":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ACCESSCODE_LIMIT_REACHED",
              l: l
            }),
            type: "error"
          });
          break;
        }
      case "not_allowed":
      default:
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ACCESSCODE_NOT_ALLOWED",
              l: l
            }),
            type: "error"
          });
          break;
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formConfig]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["email"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.digitalProductAuthentication.requiredField",
      l: l
    }),
    label: l("reactShop.digitalProductAuthentication.email"),
    name: "email",
    required: true,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["token"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.digitalProductAuthentication.requiredField",
      l: l
    }),
    label: l("reactShop.digitalProductAuthentication.token"),
    name: "token",
    required: true,
    value: token,
    TextfieldProps: {
      variant: "outlined"
    }
  }), !(0, _isEmpty.default)(formMessageObj) && formMessageObj.message && /*#__PURE__*/_react.default.createElement(_Message.default, {
    text: formMessageObj.message,
    type: formMessageObj.type
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.button, "mco-shop-digital-product-authentication-form__button")
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: l("reactShop.digitalProductAuthentication.buttons.save"),
    locked: formLocked,
    ButtonProps: {
      color: "primary",
      variant: "contained"
    },
    type: "submit"
  })));
};
var Form = function Form(_ref2) {
  var lang = _ref2.lang,
    onSubmit = _ref2.onSubmit;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    search = _useLocation.search;
  var css = (0, _Form.default)();
  var params = new URLSearchParams(search);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.form, "mco-shop-digital-product-authentication-form")
  }, /*#__PURE__*/_react.default.createElement(_reactForm.default, {
    action: "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.DigitalProductApi/SendAccessCodeMail.api"),
    method: "POST",
    contentType: "formData",
    onAfterSubmit: function onAfterSubmit(data) {
      if (onSubmit) onSubmit(data);
    }
  }, /*#__PURE__*/_react.default.createElement(FormContent, {
    lang: lang,
    token: params.get("token")
  })));
};
var _default = Form;
exports.default = _default;